import React from "react";
import styled from "styled-components";

import { LOGIN_ERROR_TYPE } from "../../../core/auth";
import { COLOR } from "../../../components/theme";
import { Message } from "../../../components";

const Wrapper = styled.div`
  margin: 24px 0;

  button {
    cursor: pointer;
    width: 100%;
    font-size: 15px;
    font-weight: 400;
  }
`;

export const LoginError = ({ errorCode, additionalDesc, children, color, fontFamily }) => {
  let title,
    desc = "";

  switch (errorCode) {
    case LOGIN_ERROR_TYPE.NO_ALLOWED_FACTORS:
      title = "Login not allowed";
      desc = `Unfortunately, your account is not linked to a mobile number.`;
      break;

    default:
      title = "Login failed";
      desc = `Oops! Something went wrong while signing you in securely.`;
      break;
  }

  return (
    <>
      <Message
        severity="warning-or-significant"
        bg={COLOR.RED_100}
        title={title}
        color={color}
        fontFamily={fontFamily}
      >
        {desc} {additionalDesc}
      </Message>
      <Wrapper>{children}</Wrapper>
    </>
  );
};
